import { useQuery } from '@tanstack/react-query'
import { allReportsQuery, type ReportLink } from '../api/easeedeskBoards'
import { hrefOf } from '../overview/href'
import { Content } from '../ui/Shell'

/**
 * "Dashboards & Reports" - `Easeedesk::all_reports`, macheta
 * `views/version-3/dashboards/easeedesk/all_reports/index.php`.
 *
 * Acelasi titlu, aceleasi butoane, in aceeasi ordine si cu aceleasi trei
 * culori. Legaturile trec prin `hrefOf`: ce s-a mutat deja in v4 (tabloul
 * ITIL din Overview) se deschide in /app, restul raman in portal.
 *
 * Foaia e cea din macheta, cuvant cu cuvant, cu o singura schimbare:
 * selectoarele sunt prinse sub `.od-all-reports`. In portal blocul `<style>`
 * traia cat pagina; aici pagina nu se mai reincarca, si un `.button` liber ar
 * vopsi butoane de pe alte ecrane.
 */

const STYLE = `
.od-all-reports .button {
    background-color: #f8ab1e;
    border-radius: 12px;
    color: white;
    padding: 10px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
    margin: 4px 2px;
    cursor: pointer;
}
.od-all-reports .button1 {
    background-color: #0c834d;
    border-radius: 12px;
    color: white;
    padding: 10px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
    margin: 4px 2px;
    cursor: pointer;
}
.od-all-reports .button2 {
    background-color: #1c87c9;
    border-radius: 12px;
    color: white;
    padding: 10px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 18px;
    margin: 4px 2px;
    cursor: pointer;
}
/* Regula generala a temei - a:hover { color: #23527c } cu subliniere -
   castiga altfel in fata claselor de mai sus, si scrisul devine albastru
   inchis pe verde: aproape nevazut. */
.od-all-reports a.button:hover, .od-all-reports a.button:focus,
.od-all-reports a.button1:hover, .od-all-reports a.button1:focus,
.od-all-reports a.button2:hover, .od-all-reports a.button2:focus {
    color: white;
    text-decoration: none;
}
.od-all-reports a.button:hover { background-color: #d99312; }
.od-all-reports a.button1:hover { background-color: #09623a; }
.od-all-reports a.button2:hover { background-color: #1670a8; }
`

function Button({ link, tone }: { link: ReportLink; tone: string }) {
  const href = hrefOf(link.url)
  if (!href) return null
  return (
    <span>
      <a
        href={href}
        {...(link.blank ? { target: '_blank', rel: 'noreferrer' } : {})}
        className={tone}
        {...(link.title ? { title: link.title } : {})}
      >
        {link.label}
      </a>
    </span>
  )
}

export function AllReportsPage() {
  const q = useQuery(allReportsQuery)
  const page = q.data

  return (
    <Content>
      <style>{STYLE}</style>
      <div className="od-all-reports">
        {page?.show ? (
          <>
            <center>
              <h1 style={{ paddingBottom: '10px' }}>{page.title}</h1>
            </center>
            <p>
              {page.groups.map((group) =>
                group.links.map((link, i) => <Button key={`${group.tone}-${i}`} link={link} tone={group.tone} />)
              )}
            </p>
          </>
        ) : null}
      </div>
    </Content>
  )
}
